import { NgModule } from '@angular/core';
import { CollapsibleComponent } from './collapsible.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [CollapsibleComponent],
  exports: [CollapsibleComponent]
})
export class CollapsibleModule {}
